var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarcodeGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA5BEF17-9288-4A3E-B795-330E6DB2E9D7_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voucher",
    transform: "translate(-360.000000, -383.000000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(208.000000, 285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(152.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Barcode_Gray-16px",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L3,0 C2.26666667,0 1.66666667,0.663157895 1.66666667,1.47368421 L1.66666667,3.68421053",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0 L13,0 C13.7333333,0 14.3333333,0.663157895 14.3333333,1.47368421 L14.3333333,3.68421053",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,14 L3,14 C2.26666667,14 1.66666667,13.3368421 1.66666667,12.5263158 L1.66666667,10.3157895",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,14 L13,14 C13.7333333,14 14.3333333,13.3368421 14.3333333,12.5263158 L14.3333333,10.3157895",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L16,7",
    id: "Stroke-9"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcodeGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Barcode_Gray-16px.58eb1d68b124d13e84aec0e381f8f857.svg";
export { ForwardRef as ReactComponent };